// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"f15aa9c058f603db113c","303":"e2eafe24de47c4c9d587","495":"7f2dbdfb076782b89af4"}[chunkId] + ".js";
};